import { render } from "./ConfigurationEmail.vue?vue&type=template&id=003b6b88&scoped=true"
import script from "./ConfigurationEmail.vue?vue&type=script&lang=js"
export * from "./ConfigurationEmail.vue?vue&type=script&lang=js"

import "./ConfigurationEmail.vue?vue&type=style&index=0&id=003b6b88&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003b6b88"]])

export default __exports__